export default __webpack_public_path__ + "static/media/logo.45d22a15.png";